import React from 'react';
import HeroSection from '../../Components/about/HeroSectio';
import WhoWeAre from '../../Components/about/WhoWeAre';
import WhatWeOffer from '../../Components/about/WhatWeOffer';
import WhyChooseUs from '../../Components/about/WhyChooseUs';
import Testimonials from '../../Components/about/Testimonials';
import CallToAction from '../../Components/about/CallToAction';

const AboutPage = () => {
    return (
        <div className='pt-[110px] space-y-10 overflow-hidden'>
            <div data-aos="fade-up">
                <HeroSection />
            </div>
            <div data-aos="fade-up" data-aos-delay="100">
                <WhoWeAre />
            </div>
            <div data-aos="fade-up" data-aos-delay="200">
                <WhatWeOffer />
            </div>
            <div >
                <WhyChooseUs />
            </div>
            <Testimonials />
            <div >
                <CallToAction />
            </div>
        </div>
    );
};

export default AboutPage;
